export default __webpack_public_path__ + "static/media/angle.65851878.svg";